export default {
      id: "comment-filled-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#comment-filled",
      toString: function () {
        return this.url;
      }
    }